import { useEffect, useState } from 'react';

/**
 * Horloge partagée par composant. Sert à recalculer la fraîcheur et les minutes restantes
 * sans refetch : une donnée affichée vieillit visiblement (ADR-0004).
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
